export default {"src":"/_next/static/media/BlossomLabsLogo.b57528a5.svg","height":217,"width":221,"blurWidth":0,"blurHeight":0};